module.exports = __webpack_public_path__ + "img/null@2x.0df06154.png";